import { createTheme } from "@mui/material/styles";
import Dashboard from "./components/dashboard-page-components/Dashboard";
import Login from "./components/login-page-components/Login";
import { AuthProvider } from "./contexts/AuthContext";
import { Route, Switch } from "react-router";
import ProtectedRoute from "./components/ProtectedRoute";
import { DatabaseProvider } from "./contexts/DatabaseContext";
import Register from "./components/register-page-components/Register";
import Purchases from "./components/purchases-page-components/Purchases";
import { ThemeProvider } from "@emotion/react";
import Agreement from "./components/Agreement";
import Statistics from "./components/stats-page-components/Statistics";
import NavBar from "./components/NavBar";
import Box from "@mui/material/Box";
const theme = createTheme({
  typography: {
    fontFamily: `Gotham Pro`,
  },
});

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>

        <Switch>
          <Box sx={{height: "100vh"}}>
            <NavBar />

          <Route path="/login">
            <Login />
          </Route>
          <Route path="/agreement">
            <Agreement />
          </Route>
          <DatabaseProvider>
            <ProtectedRoute exact path="/" component={Dashboard} />
            <ProtectedRoute path="/register" component={Register} />
            <ProtectedRoute path="/purchases" component={Purchases} />
            <ProtectedRoute path="/stats" component={Statistics} />

          </DatabaseProvider>

          </Box>
        </Switch>

      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
